<template>
    <div>
        <b-overlay :show="loading" :variant="'light'" :opacity="0.85" :blur="'2px'" rounded="sm">
            <b-card header-tag="header" footer-tag="footer">
                <b-card-text>
                    <vue-typed-js :strings="['cooking', 'DIY', 'programming', 'book review', 'law', 'meditation', 'research']" :loop="true" :backDelay="3000" :typeSpeed="100">
                        <h2>Create a <span class="typing"></span> blog with Google Docs</h2>
                    </vue-typed-js>
                    <p class="filler-text"><i>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. In ante neque, accumsan non tristique ac, suscipit sit amet metus. Aliquam ornare vehicula justo. Curabitur bibendum mauris odio, sed dictum lorem aliquam sed. Praesent a est efficitur, malesuada est non, ullamcorper sem. Ut eleifend ullamcorper massa rutrum congue. Etiam molestie mi sit amet nisi tristique, a pharetra tellus ultricies. Vestibulum tortor arcu, volutpat at aliquet cursus, fermentum sit amet quam. Phasellus feugiat velit at lacinia eleifend. Quisque non porta ligula, nec tempus urna. Donec eget augue eget libero hendrerit viverra sed lobortis enim. Sed tristique ante eu ligula consequat sodales. In posuere ultrices erat, a euismod massa semper eget.
                        </i>
                    </p>
                </b-card-text>
            </b-card>
            <div class="mt-4">
                <div style="width: 100%; text-align: right">
                    <g-signin-button class="btn btn-primary btn-lg" :params="googleSignInParams" @success="onSignInSuccess" @error="onSignInError">
                        Create a Blog With DocPusher <i class="fas fa-arrow-right"></i>
                    </g-signin-button>
                </div>
            </div>
        </b-overlay>
        <hr />
        <div class="mt-4">
            <div style="text-align: center">
              <h1><i><b>How does it work?</b></i></h1>
            </div>
            <div class="aligned mobile-headline-spacing">
                <img src="../assets/www.svg" class="m-4" style="max-width: 100px; vertical-align: middle;" />
                <span class="headline">
                    You pick a DocPusher domain and create your blog.
                </span>
            </div>
            <div class="aligned mobile-headline-spacing">
                <img src="../assets/folder.svg" class="m-4" style="max-width: 100px; vertical-align: middle;" />
                <span class="headline">
                    We share a dedicated Google Drive folder with you.
                </span>
            </div>
            <div class="aligned mobile-headline-spacing">
                <img src="../assets/document.svg" class="m-4" style="max-width: 100px; vertical-align: middle;" />
                <span class="headline">
                    Google Docs you create and edit in this folder are automatically queued for publishing.
                </span>
            </div>
            <div class="aligned mobile-headline-spacing">
                <img src="../assets/tick.svg" class="m-4" style="max-width: 100px; vertical-align: middle;" />
                <span class="headline">
                    When you're ready, you can publish the changes using the DocPusher website.
                </span>
            </div>
            <div class="aligned mobile-headline-spacing">
                <img src="../assets/doc-convert-to-webpage.svg" class="m-4" style="max-width: 100px; vertical-align: middle;" />
                <span class="headline">
                    Your Google Docs are automatically converted into rich webpages for your blog.
                </span>
            </div>
        </div>
        <div class="mb-4" style="width: 100%; text-align: right">
            <g-signin-button class="btn btn-primary btn-lg" :params="googleSignInParams" @success="onSignInSuccess" @error="onSignInError">
                Pick your blog domain <i class="fas fa-arrow-right"></i>
            </g-signin-button>
        </div>
        <hr />
        <div class="mt-4">
            <div style="text-align: center">
              <h1><i><b>A Few of Our Features</b></i></h1>
            </div>
            <div class="aligned mobile-headline-spacing">
                <img src="../assets/google-docs.svg" class="m-4" style="max-width: 100px; vertical-align: middle;" />
                <span class="headline">
                    Publish Google Docs as rich blog posts.
                </span>
            </div>
        </div>
        <div class="mt-4">
            <div class="aligned mobile-headline-spacing">
                <img src="../assets/themes.svg" class="m-4" style="max-width: 100px; vertical-align: middle;" />
                <span class="headline">
                    Pick from our themes to match your style.
                </span>
            </div>
        </div>
        <div class="mt-4">
            <div class="aligned mobile-headline-spacing">
                <img src="../assets/stopwatch.svg" class="m-4" style="max-width: 100px; vertical-align: middle;" />
                <span class="headline">
                    Create your first blog in less than a minute.
                </span>
            </div>
        </div>
        <div class="mt-4">
            <div class="aligned mobile-headline-spacing">
                <img src="../assets/code.svg" class="m-4" style="max-width: 100px; vertical-align: middle;" />
                <span class="headline">
                    <a href="https://docs.google.com/document/d/1UH0L4P0Irse_l71CGg9QOzsZYo1jUWxRyZA3Dw3nJdI/preview#heading=h.s6tefh8qv1zt" target="_blank">Syntax highlighting support</a> for all of your code snippets.
                </span>
            </div>
        </div>
        <div class="mt-4">
            <div class="aligned mobile-headline-spacing">
                <img src="../assets/diagram.svg" class="m-4" style="max-width: 100px; vertical-align: middle;" />
                <span class="headline">
                    Built in support for <a href="https://docs.google.com/document/d/1UH0L4P0Irse_l71CGg9QOzsZYo1jUWxRyZA3Dw3nJdI/preview#heading=h.qtg7eao9ol4v" target="_blank"> Google Draw diagrams.</a> 
                </span>
            </div>
        </div>
        <div class="mt-4">
            <div class="aligned mobile-headline-spacing">
                <img src="../assets/forbidden.svg" class="m-4" style="max-width: 100px; vertical-align: middle;" />
                <span class="headline">
                    No password needed, just login with your Google account.
                </span>
            </div>
        </div>
        <div class="mt-4">
            <div class="aligned mobile-headline-spacing">
                <img src="../assets/speed.svg" class="m-4" style="max-width: 100px; vertical-align: middle;" />
                <span class="headline">
                    Free super-fast hosting included.
                </span>
            </div>
        </div>
        <div class="mb-4" style="width: 100%; text-align: right">
            <g-signin-button class="btn btn-primary btn-lg" :params="googleSignInParams" @success="onSignInSuccess" @error="onSignInError">
                Sound good? Write your first post with DocPusher <i class="fas fa-arrow-right"></i>
            </g-signin-button>
        </div>
        <hr />
        <div class="mt-5">
            <div style="text-align: center" class="mb-5">
              <h1><i><b>Want a demo? Select a theme to see what the example doc will look like when published.</b></i></h1>
            </div>
            <div class="card-columns">
                <b-card v-on:click="set_theme(theme)" v-bind:img-src="get_theme_image(theme)" img-alt="Minima" img-top tag="article" class="mb-2 theme-card" v-for="theme in themes" v-bind:key="theme">
                    <div class="box-overlay">
                        <p class="box-overlay-text" v-bind:class="[(theme === demo_theme_selected) ? 'selected-theme': '' ]">
                            {{theme}}
                        </p>
                    </div>
                </b-card>
            </div>
            <b-card no-body class="mb-4" id="demo-site">
                <b-tabs card v-model="demo_tab_shown">
                    <b-tab class="p-0">
                        <template v-slot:title>
                            <b><i class="fas fa-file-alt"></i> Example Google Doc: <i>Hello World! (Example Blog Post)</i></b>
                        </template>
                        <iframe class="doc-example" src="https://docs.google.com/document/d/e/2PACX-1vT7OLhPJSFKHtmBfzpjMXfSaejIuuJXBnM06kQf-9Z1aIxs-wlXUGnP_YZ-3cX0PvfgrhDfLbnCOw_o/pub?embedded=true"></iframe>
                    </b-tab>
                    <b-tab class="p-0">
                        <template v-slot:title>
                            <b><i class="fas fa-globe-americas"></i> Generated Webpage
                                (<i>{{demo_theme_selected}} Theme</i>)
                            </b>
                        </template>
                        <div>
                            <iframe class="doc-example" v-bind:src="demo_theme_map[demo_theme_selected]"></iframe>
                        </div>
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
        <div style="width: 100%; text-align: right">
            <g-signin-button class="btn btn-primary btn-lg" :params="googleSignInParams" @success="onSignInSuccess" @error="onSignInError">
                Select a theme for your DocPusher blog <i class="fas fa-arrow-right"></i>
            </g-signin-button>
        </div>
        <hr />
    </div>
</template>
<script>
import api from '../libs/api.js';
import $ from 'jquery'

export default {
    name: 'HomePage',
    props: {},
    // On page load
    mounted() {
        if (this.is_authenticated) {
            this.$router.push('/sites')
        }
    },
    data() {
        return {
            /**
             * The Auth2 parameters, as seen on
             * https://developers.google.com/identity/sign-in/web/reference#gapiauth2initparams.
             * As the very least, a valid client_id must present.
             * @type {Object}
             */
            googleSignInParams: {
                client_id: '732190607793-0s6gb272lm9gd8c05sfmbb8m3l8csh5j.apps.googleusercontent.com'
            },
            /*
              Is the user authenticated? If so, redirect them.
            */
            is_authenticated: (localStorage.getItem('auth_token') !== null),
            // Show loader
            loading: false,
            // Demo tab index (which tab is shown)
            demo_tab_shown: 0,
            // Which theme is selected for the demo renderer
            demo_theme_selected: 'Leaf',
            // Static of themes
            themes: [
                'Leaf',
                'Minima',
                'Neo-HPSTR',
                'Matjek',
                'Hacker-Blog',
                'Emerald'
            ],
            // Map of theme names to their preview URLs for the demo
            demo_theme_map: {
                'Minima': 'https://minimademo.docpusher.com/2020/08/01/hello-world!-(example-blog-post)-SVVZnrVf.html',
                'Matjek': 'https://matjekdemo.docpusher.com/2020/08/01/hello-world!-(example-blog-post)-fJhqqYXx.html',
                'Leaf': 'https://leafdemo.docpusher.com/2020/08/01/hello-world!-(example-blog-post)-z2zLPAzA.html',
                'Neo-HPSTR': 'https://neohpstr.docpusher.com/hello-world!-(example-blog-post)-w2CEt5If/',
                'Hacker-Blog': 'https://hackerblogdemo.docpusher.com/2020/08/01/hello-world!-(example-blog-post)-vNIl8azC.html',
                'Emerald': 'https://emeralddemo.docpusher.com/2020/08/01/hello-world!-(example-blog-post)-pgnBVSop.html',
            },
        }
    },
    methods: {
        set_theme: function(theme) {
            $('html, body').animate({
                scrollTop: $("#demo-site").offset().top
            }, 1000);
            this.demo_tab_shown = 1;
            this.demo_theme_selected = theme;
        },
        get_theme_image: function(theme) {
            return require(`@/assets/themes/${theme.toLowerCase()}.png`);
        },
        async onSignInSuccess(googleUser) {
            // `googleUser` is the GoogleUser object that represents the just-signed-in user.
            // See https://developers.google.com/identity/sign-in/web/reference#users
            const profile = googleUser.getBasicProfile();

            const auth_token = googleUser.getAuthResponse().id_token;

            this.loading = true;

            try {
                var auth_result = await api.get_authentication_token(auth_token);
                this.loading = false;
            } catch (e) {
                this.loading = false;
                console.error(`Error occurred while authenticating: `);
                console.error(e);
                alert('Error occurred while authenticating, please try again.');
                return
            }

            // Store some metadata in localStorage for later
            localStorage.setItem(
                'profile',
                JSON.stringify({
                    'name': profile.getName(),
                    'profile_image': profile.getImageUrl(),
                })
            );

            // Set the auth token in localStorage
            localStorage.setItem(
                'auth_token',
                auth_result.auth_token
            );

            // Emit an event to refresh profile data
            const refresh_profile_event = document.createEvent("Event");
            refresh_profile_event.initEvent("refreshProfile",true,true);
            document.addEventListener("refreshProfile",refresh_profile_event,false);
            document.dispatchEvent(refresh_profile_event);

            this.is_authenticated = true;
            this.$router.push('/sites');
        },
        onSignInError(error) {
            // `error` contains any error occurred.
            console.log('OH NOES', error)
        }
    },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.headline {
  font-weight: bold;
  font-size: 35px;
}

.aligned {
    display: flex;
    align-items: center;
}

.theme-card {
    text-align: center;
    max-width: 300px;
    width: 100vw;
    cursor: pointer;
    margin-left: auto;
    margin-right: auto;
}

.theme-card:after {
    content: " ";
    z-index: 2;
    display: block;
    position: absolute;
    height: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
}

.theme-card:hover:after {
    content: " ";
    z-index: 2;
    display: block;
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0);
}

.theme-card div {
    padding: 0px !important;
}

.box-overlay {
    position: absolute;
    bottom: 8px;
    width: 100%;
    z-index: 10;
}

.selected-theme {
    color: #00aaff !important;
}

.box-overlay-text {
    /* Readable font for overlay */
    margin-bottom: 0px;
    font-family: 'Anton', sans-serif;
    font-size: 1.5em;
    color: white;
    letter-spacing: 1px;
    text-shadow: 2px 2px 0 #000,
        -2px -2px 0 #000,
        2px -2px 0 #000,
        -2px 2px 0 #000,
        0px 2px 0 #000,
        2px 0px 0 #000,
        0px -2px 0 #000,
        -2px 0px 0 #000,
        2px 2px 5px #000;
}

.doc-example {
    border: 0px;
    width: 100%;
    height: 50vh;
    min-height: 300px;
    overflow-y: scroll;
}

.doc-example::-webkit-scrollbar {
    -webkit-appearance: none;
}

.doc-example::-webkit-scrollbar:vertical {
    width: 11px;
}

.doc-example::-webkit-scrollbar:horizontal {
    height: 11px;
}

.doc-example::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 2px solid white;
    /* should match background, can't be transparent */
    background-color: rgba(0, 0, 0, .5);
}

@media all and (min-width:160px) and (max-width: 1024px) {
  .mobile-headline-spacing {
    margin-bottom: 50px !important;
  }
}
</style>